// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconAlphaD = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path
      fillRule="evenodd"
      d="M11.667 17H8.42V6.948h3.276c1.498 0 2.716.336 3.57.98 1.092.826 1.652 2.17 1.652 3.948 0 1.54-.42 2.842-1.302 3.752-.84.868-2.128 1.372-3.948 1.372m-.546-8.554h-.952v7.042h1.526c2.058 0 3.388-1.022 3.388-3.542 0-2.422-1.078-3.5-3.962-3.5"
    />,
    <path
      fillRule="evenodd"
      d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2M4 12a8 8 0 1116 0 8 8 0 01-16 0"
    />
  );
export default SvgIconAlphaD;
